import { BrowserRouter, Route,Routes } from 'react-router-dom';

import { BalloonPage } from '@/pages/balloon/BalloonPage';
import { HistoryPage } from '@/pages/history/HistoryPage';
import { HomePage } from '@/pages/home';
import { JettonPage } from '@/pages/jetton/JettonPage';
import { JettonHistoryPage } from '@/pages/jetton-history/JettonHistoryPage';
import { LeaderboardPage } from '@/pages/leaderboard/LeaderboardPage';
import { LoadingPage } from '@/pages/loading/LoadingPage';
import { MinesPage } from '@/pages/mines/MinesPage';
import { ProfilePage } from '@/pages/profile/ProfilePage';
import { RollsPage } from '@/pages/rolls/RollsPage';
import { ShopPage } from '@/pages/shop/ShopPage';
import { ROUTES } from '@/shared/config/constants';

import { Layout } from '../layout/Layout';

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.HOME} element={<LoadingPage />} />
        <Route element={<Layout />}>
          <Route path={ROUTES.GAMES} element={<HomePage />} />
          <Route path={ROUTES.PROFILE} element={<ProfilePage />} />
          <Route path={ROUTES.SHOP} element={<ShopPage />} />
          <Route path={ROUTES.LEADERBOARD} element={<LeaderboardPage />} />
          <Route path={ROUTES.HISTORY} element={<HistoryPage />} />
          <Route path={ROUTES.JETTON_HISTORY} element={<JettonHistoryPage />} />
          <Route path={ROUTES.ROLLS} element={<RollsPage />} />
          <Route path={ROUTES.JETTON} element={<JettonPage />} />
          <Route path={ROUTES.MINES} element={<MinesPage />} />
          <Route path={ROUTES.BALLOON} element={<BalloonPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
